export default {
  date: 'July 26, 2024',
  title: 'Stop losing clients because of a long preparation of property plans',
  description: 'AI will do all the work for you',
  id: 'AI-will-work-for-you',
  jsx: () => (
    <div class='novelty__text'>
      <p>AI will do all the work for you: 2D, 3D layouts, 360 in 24 hours</p>
      <p class='margin-none'>In one business day our AI will create:</p>
      <ul>
        <li>2D plan</li>
        <li>3D plan</li>
        <li>Renderings</li>
        <li>360-degree video</li>
      </ul>
      <p>Our research on 40,000 ads showed a conversion rate increase from 12.7% to 25%.</p>
      <p class='margin-none'>Using Getfloorplan AI, buyers:</p>
      <ul>
        <li>are more likely to click on ads</li>
        <li>spend more time on the property’s page</li>
        <li>save to favorites</li>
        <li>share posts and click on the "call" button</li>
      </ul>
      <p>Try our AI today to attract a larger percentage of your target audience, double your conversion rate, and outperform your competitors.</p>
    </div>
  ),
  thumb: 'news/25.webp',
};
